export const ZoneConfig = [{
    type: 'live',
    name: '正在直播',
    navName: '直播',
    tid: 'live',
    morelink: '//live.bilibili.com/',
    component: 'Live'
  },
  {
    type: 'douga',
    name: '動畫',
    zid: 1554,
    tid: 1,
    morelink: '/v/douga',
    component: 'Zone'
  },
  {
    type: 'anime',
    name: '番劇',
    alias: '番劇',
    zid: 1556,
    tid: 13,
    morelink: '//www.bilibili.com/anime/',
    component: 'Anime',
  },
  {
    type: 'guochuang',
    name: '國創',
    alias: '國產動畫',
    zid: 1919,
    tid: 168,
    morelink: '//www.bilibili.com/guochuang/',
    component: 'Guochuang',
  },
  {
    type: 'manga',
    name: '漫畫',
    alias: '漫畫',
    // zid: 1919,
    // tid: 168,
    morelink: '//manga.bilibili.com/',
    component: 'Manga',
  },
  {
    type: 'music',
    name: '音樂',
    zid: 1558,
    tid: 3,
    morelink: '/v/music',
    component: 'Zone',
  },
  {
    type: 'dance',
    name: '舞蹈',
    zid: 1560,
    tid: 129,
    morelink: '/v/dance',
    component: 'Zone',
  },
  {
    type: 'game',
    name: '遊戲',
    zid: 1562,
    tid: 4,
    morelink: '/v/game',
    component: 'Zone',
  },
  {
    type: 'technology',
    name: '知識',
    zid: 1624,
    tid: 36,
    morelink: '/v/technology',
    component: 'Zone',
  },
  {
    type: 'cheese',
    name: '課堂',
    morelink: '/cheese',
    component: 'Cheese',
  },
  {
    type: 'digital',
    name: '数位',
    tid: 188,
    morelink: '/v/digital',
    component: 'Zone',
  },
  {
    type: 'life',
    name: '生活',
    zid: 1564,
    tid: 160,
    morelink: '/v/life',
    component: 'Zone',
  },
  {
    type: 'food',
    name: '美食',
    zid: 2273,
    tid: 211,
    morelink: '/v/food',
    component: 'Zone'
  },
  {
    type: 'animal',
    name: '動物圈',
    tid: 217,
    morelink: '/v/animal',
    component: 'Zone'
  },
  {
    type: 'kichiku',
    name: '鬼畜',
    zid: 1566,
    tid: 119,
    morelink: '/v/kichiku',
    component: 'Zone',
  },
  {
    type: 'fashion',
    name: '時尚',
    zid: 1568,
    tid: 155,
    morelink: '/v/fashion',
    component: 'Zone',
  },
  {
    type: 'information',
    name: '資訊',
    tid: 202,
    morelink: '/v/information',
    component: 'ZoneInformation',
  },
  {
    type: 'ent',
    name: '娛樂',
    zid: 1570,
    tid: 5,
    morelink: '/v/ent',
    component: 'Zone',
  },
  {
    type: 'read',
    name: '專欄',
    morelink: '//www.bilibili.com/read/home',
    component: 'Article',
  },
  {
    type: 'movie',
    name: '電影',
    zid: 1572,
    tid: 23,
    morelink: '/movie',
    component: 'Zone',
  },
  {
    type: 'teleplay',
    name: '電視劇',
    navName: 'TV劇',
    zid: 1574,
    tid: 11,
    morelink: '/tv',
    component: 'Zone',
  },
  {
    type: 'cinephile',
    name: '影視',
    zid: 2207,
    tid: 181,
    morelink: '/v/cinephile',
    component: 'Zone',
  },
  {
    type: 'documentary',
    name: '紀錄片',
    zid: 2257,
    tid: 177,
    morelink: '/documentary',
    component: 'Zone',
  }
]

//楼层广告配置
export const FloorAdConfig = [{
    pos: 0,
    dataLocId: 40
  },
  {
    pos: 2,
    dataLocId: 42
  },
  {
    pos: 4,
    dataLocId: 44
  }
]